'use strict';
import $ from 'jquery';

export default class StickyAnchorMenu {
    static init() {
        $('.sticky-anchor-menu').each((index, el) => {
            new StickyAnchorMenu($(el));
        });
    }

    constructor($el) {
        this.menu = $el;
        this.menuHeight = this.menu.outerHeight();
        this.headerHeight = 75; // Adjust if your header height differs
        this.stickyOffset = this.headerHeight + this.menuHeight;
        this.menuLinks = this.menu.find('.a-menu-link');
        this.sectionIds = this.getValidSectionIds();

        this.initSticky();
        this.events();
        this.setInitialState();
    }

    getValidSectionIds() {
        return this.menuLinks.map((i, link) => {
            const href = $(link).attr('href');
            return href && href.startsWith('#') ? href : null;
        }).get().filter(Boolean);
    }

    initSticky() {
        // Set initial styles for sticky behavior
        this.menu.css({
            'top': `${this.headerHeight}px`,
            'z-index': 1020
        });
    }

    toggleSticky() {
    const scrollTop = $(window).scrollTop();
    const windowWidth = $(window).width();

    // Disable sticky behavior for screens <= 990px
    if (windowWidth <= 990) {
        this.menu.removeClass('is-sticky').css({
            position: '',
            top: '',
            width: '',
            transition: ''
        });
        return; // Stop execution if below 990px
    }

    // Recalculate the original menu offset on resize
    if (typeof this.originalMenuOffset === 'undefined' || this.needsRecalculation) {
        this.originalMenuOffset = this.menu.offset().top - this.headerHeight;
        this.needsRecalculation = false; // Reset flag after recalculating
    }

    // Detect scroll direction
    if (scrollTop > this.lastScrollTop) {
        // Scrolling down: Stick when reaching the trigger point
        if (scrollTop >= this.originalMenuOffset) {
            this.menu.addClass('is-sticky');
        }
    } else {
        // Scrolling up: Unstick smoothly when reaching the original position
        if (scrollTop <= this.originalMenuOffset) {
            this.menu.removeClass('is-sticky').css({
                transition: 'top 0.3s ease-in-out'
            });
        }
    }

    this.lastScrollTop = scrollTop;
}

// Handle window resize to recalculate offsets and check screen size
handleResize() {
    this.needsRecalculation = true; // Flag to recalculate on the next scroll
    this.toggleSticky(); // Apply or remove sticky behavior on resize
}

// Attach resize event listener in `events()`
events() {
    let ticking = false;

    $(window).on('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                this.toggleSticky();
                this.updateActiveSection();
                ticking = false;
            });
            ticking = true;
        }
    });

    $(window).on('resize', () => {
        this.handleResize();
    });

    // Smooth scroll click handler
    this.menuLinks.on('click', (e) => {
        const target = $(e.currentTarget).attr('href');
        if (target && target.startsWith('#')) {
            e.preventDefault();
            this.smoothScrollTo(target);
        }
    });
}


    updateActiveSection() {
        const scrollPosition = $(window).scrollTop() + this.stickyOffset;
        let activeSection = null;

        this.sectionIds.forEach(id => {
            const $section = $(id);
            if ($section.length) {
                const sectionTop = $section.offset().top;
                const sectionBottom = sectionTop + $section.outerHeight();

                if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                    activeSection = id;
                }
            }
        });

        this.menuLinks
            .removeClass('active')
            .filter(`[href="${activeSection}"]`)
            .addClass('active');
    }

    smoothScrollTo(target) {
        const $target = $(target);
        if ($target.length) {
            $('html, body').stop().animate({
                scrollTop: $target.offset().top - this.stickyOffset
            }, 300, 'swing', () => {
                window.location.hash = target;
            });
        }
    }

    setInitialState() {
        this.toggleSticky();
        this.updateActiveSection();
    }
}
